import { useDispatch } from 'react-redux';
import { useEffect, useCallback, useState } from 'react';
import { useResizeObserver } from 'js/hooks/useResizeObserver';

import { updateHeaderHeight } from '../store/actions';

export const useUpdateHeaderHeight = () => {
    const dispatch = useDispatch();
    const [offsetHeight, setOffsetHeight] = useState(0);

    useEffect(() => {
        dispatch(updateHeaderHeight({ height: offsetHeight }));

        return () => {
            dispatch(updateHeaderHeight({ height: offsetHeight, decrement: true }));
        };
    }, [offsetHeight, dispatch]);

    return useResizeObserver({
        callback: useCallback((entries) => {
            setOffsetHeight(entries[0].target.offsetHeight);
        }, [])
    });
};
